module.exports = __webpack_public_path__ + "img/vampire_lord_small.b5be60f4.png";